import { render } from "./LinksContact.vue?vue&type=template&id=3a1459e0"
import script from "./LinksContact.vue?vue&type=script&lang=js"
export * from "./LinksContact.vue?vue&type=script&lang=js"

import "./LinksContact.vue?vue&type=style&index=0&id=3a1459e0&lang=css"

import exportComponent from "C:\\MesProjets\\Labs\\akdevmatik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__